import { render } from "./whoWeAre.vue?vue&type=template&id=9f170fd2&scoped=true"
import script from "./whoWeAre.vue?vue&type=script&lang=js"
export * from "./whoWeAre.vue?vue&type=script&lang=js"

import "./whoWeAre.vue?vue&type=style&index=0&id=9f170fd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f170fd2"]])

export default __exports__